<!DOCTYPE html>
<div class="container">
    <div class="notification-wrap">
        <img (click)="goBack()" src="assets/images/close-circle.png" />
    </div>
    <iframe
        #sovendusIframe
        src="assets/sovendus-wrapper.html"
        class="sovendus-frame"
        scrolling="no"
        allowfullscreen="allowfullscreen"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
    </iframe>
</div>
